module.exports = __webpack_public_path__ + "bf7eb06040658f95e2db7c41362fc1df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tegaopin.png
// module id = 178
// module chunks = 1